import { render, staticRenderFns } from "./ProjectMemberSelect.vue?vue&type=template&id=c0bb2922&scoped=true&"
import script from "./ProjectMemberSelect.vue?vue&type=script&lang=ts&"
export * from "./ProjectMemberSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectMemberSelect.vue?vue&type=style&index=0&id=c0bb2922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb2922",
  null
  
)

export default component.exports